export const localization = {
  en: {
    medication: 'Medication Record',
    immunization: 'Immunization Record',
    print: 'Print',
    patientName: 'Patient Name:',
    dob: 'DOB:'
  },
  es: {
    medication: 'Registro de Medicación',
    immunization: 'Registro de Inmunización',
    print: 'Imprimir',
    patientName: 'Nombre del paciente:',
    dob: 'Fecha de nacimiento:'
  },
  keyMapping: {
    print: 'UFD_Print_Button',
    medication: 'UFD_Print_Medication_Title',
    immunization: 'UFD_Print_Immunization_Title',
    patientName: 'UFD_Print_Patient_Name',
    dob: 'UFD_Print_DOB'
  }
}

